import {
  FlagCountResponse,
  GroupCount,
  TopicCount,
} from "../../api/Items";
import { INSIGHT_COLORS } from "../utils";

export type InsightSegment = {
  label: string;
  value: number;
  color: string;
};

export function buildInsightChartData(
  flagsCount: FlagCountResponse | undefined,
  keywordCount: GroupCount | undefined,
  topicCount: TopicCount | undefined,
  lensTopicsEnabled: boolean
) {
  const communityCount =
    flagsCount?.behaviors.groups.find(
      (g) => g.name.toUpperCase() === "COMMUNITY"
    )?.count ?? 0;
  const adverseCount = Math.max(
    (flagsCount?.behaviors.total ?? 0) - communityCount,
    0
  );
  const articlesCount =
    flagsCount?.item_types.groups.find((g) => g.name === "web_content")
      ?.count ?? 0;
  const keywordsCount = keywordCount?.total ?? 0;
  const topicsCount = lensTopicsEnabled ? topicCount?.total ?? 0 : 0;
  const totalFlags =
    adverseCount +
    communityCount +
    articlesCount +
    keywordsCount +
    topicsCount;

  const segments: InsightSegment[] = [
    {
      label: "Adverse Flags",
      value: adverseCount,
      color: INSIGHT_COLORS.adverse,
    },
    {
      label: "Community",
      value: communityCount,
      color: INSIGHT_COLORS.community,
    },
    {
      label: "Keywords",
      value: keywordsCount,
      color: INSIGHT_COLORS.keywords,
    },
    {
      label: "Articles",
      value: articlesCount,
      color: INSIGHT_COLORS.articles,
    },
  ];

  if (lensTopicsEnabled) {
    segments.push({
      label: "Topics",
      value: topicsCount,
      color: INSIGHT_COLORS.topics,
    });
  }

  const chartData =
    totalFlags > 0
      ? insightLegendSegments(segments)
      : [{ label: "No Data", value: 1, color: "#E5E7EB" }];

  return { chartData, segments, totalFlags };
}

/** Legend rows omit zero counts, including Topics when the count is 0. */
export function insightLegendSegments(segments: InsightSegment[]) {
  return segments.filter((segment) => segment.value > 0);
}
